module.exports = __webpack_public_path__ + "media/images/e-bilet/calendar-c47d0096efce4452952a603912d0ff1b.svg";